import { useEffect, useRef } from 'react';

/** Normalises a keyboard event to "ctrl+alt+s" (uses event.code so Alt combinations work on macOS). */
export function comboOf(e: KeyboardEvent): string {
  const key = e.code.startsWith('Key')
    ? e.code.slice(3).toLowerCase()
    : e.code === 'Slash'
      ? '/'
      : e.key.toLowerCase();
  return `${e.ctrlKey || e.metaKey ? 'ctrl+' : ''}${e.altKey ? 'alt+' : ''}${e.shiftKey ? 'shift+' : ''}${key}`;
}

/** Keyboard shortcuts framework (document 05, QBO set): `useHotkeys({ 'ctrl+alt+s': save })`. */
export function useHotkeys(map: Record<string, (e: KeyboardEvent) => void>, enabled = true): void {
  const ref = useRef(map);
  ref.current = map;
  useEffect(() => {
    if (!enabled) return;
    const onKey = (e: KeyboardEvent) => {
      const handler = ref.current[comboOf(e)];
      if (handler) {
        e.preventDefault();
        handler(e);
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [enabled]);
}
